import { Fragment } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Scroll } from "@phosphor-icons/react";

import { SectionHeader } from "@/components/brand-intelligence/layout/heading";
import { GlobalMarkets } from "@/components/brand-intelligence/metrics/global-markets";
import { MarketShares } from "@/components/brand-intelligence/metrics/market-shares";
import { CoreIdentity } from "@/components/card/brand-intelligence/core-identity";

export const Route = createFileRoute("/dashboard/research/_layout/$id/foundation")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Fragment>
      <SectionHeader title="Brand Foundation" icon={<Scroll className="text-warning size-6" />} iconClassName="bg-warning/10" />
      <CoreIdentity />
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 mt-6">
        <GlobalMarkets />
        <MarketShares />
      </div>
    </Fragment>
  );
}
